export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50">
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
              每日更新 · 高清免费
            </span>

            <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              天美影视 · 你的私人影院
            </h1>

            <p className="mt-3 text-base md:text-lg text-foreground-600 font-medium leading-relaxed">
              高清大片，随时随地免费看
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl lg:max-w-none">
              天美影视汇聚超过三万部电影作品，覆盖动作大片、悬疑推理、科幻巨制、经典港片、动画世界等全品类内容，每日更新最新影片资源。
              无论你是追求视觉震撼的特效爱好者，还是偏爱冷门佳作的深度影迷，都能在这里找到属于自己的光影时刻。
              全站高清画质、极速加载、无需注册登录，打开即看——这个夏天，让天美影视陪你度过每一个电影之夜。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-film-line text-primary-500"></i>
                <strong className="text-foreground-800">30,000+</strong> 影片资源
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-smile-line text-accent-500"></i>
                <strong className="text-foreground-800">500万+</strong> 日活用户
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-timer-flash-line text-primary-500"></i>
                <strong className="text-foreground-800">每日更新</strong> 热门新片
              </span>
            </div>

            <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollTo('index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                探索片库
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                热播排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden" style={{ aspectRatio: '16/10' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20light%20streaming%20through%20classic%20movie%20theater%20curtains%2C%20vintage%20film%20projector%20with%20soft%20glow%2C%20velvet%20red%20seats%2C%20atmospheric%20theater%20interior%2C%20nostalgic%20cinema%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast&width=1040&height=650&seq=hero-main-visual&orientation=landscape"
                alt="天美影视影院级观影体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}